/*
	Handles New and Edit matter functionality.  props.editMode determines which.
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
	createNewMatter,
	updateMatter,
	getEverythingForNewMatter,
	getEverythingForEditMatter,
	unmountNewEditMatter,
} from "../actions/matterActions";
import TwoColumnWrapper from "./TwoColumnWrapper";
import { LabeledTextInput } from "./TextInput";
import { LabeledDropDownSelect } from "./DropDownSelect";
import UsersDropDownSelect from "./UsersDropDownSelect";
import { LabeledDatePicker } from "./LabeledDatePicker";

import MaterialTabs from "./MaterialTabs";
import MatterPermissionsEditor from "./MatterPermissionsEditor";
import SelfLockoutWarning from "./SelfLockoutWarning";
import { components } from "react-select";
import { TrashBinMessage } from "./Utils/UnderSubHeaderWarningMessages";
import { IconBriefcase, IconTrash } from "@tabler/icons-react";
import {
	getClientLifecycleStatusObject,
	getDisabledStateFromLifecycleStatuses,
} from "../utilities/lifecycleStatus";
import { LabeledSwitch } from "./AsyncSwitch";
import { LabeledTextArea } from "./TextArea";

const tagLabelMap = (tag) => ({
	value: tag.name,
	label: tag.name,
});
const propTagsMap = (tag) => ({
	label: tag.tagName,
	value: tag.tagName,
});
const userOptionsMap = (user) => {
	//note: here the value is the users ID, but the <EditMatterPermissions> component expects the sub
	return { ...user, value: user.id, label: user.displayName };
};
const matterTypeMap = (matterType) => ({
	label: matterType.name,
	value: matterType.name,
	matterTypeID: matterType.id,
});
const makeClientOption = (id, availableClients) => {
	var intId = parseInt(id, 10);
	var filtered = availableClients.filter((c) => c.id === intId);
	return filtered.length
		? {
				clientID: id,
				name: filtered[0].name,
				label: filtered[0].name,
				value: filtered[0].name, // needed to autopopulate
			}
		: null;
};
const tabMap = [
	{ label: "Matter Information", url: "" },
	{ label: "Matter Permissions", url: "/permissions" },
];

const initialState = {
	name: "",
	matterID: "",
	customMatterID: "",
	client: {},
	matterType: {},
	officeBranch: {},
	assignedStaff: [],
	matterTags: [],
	dateOpened: null,
	dateClosed: null,
	needAccessToMatter: false,
};
const newMatterPermissions = {
	matterPermissionGlobalSetting: "allUsers",
	userAllowList: [],
	groupAllowList: [],
};

const clientDropdownOption = (props) => {
	return (
		<div
			className="clientSearchboxOption"
			style={{ position: "relative" }}
			title={
				props?.data?.disabledHoverText
					? props?.data?.disabledHoverText
					: ""
			}
		>
			{props?.data?.iconComponent ? (
				<span className="clientName">
					<span className="icon">{props.data.iconComponent}</span>
					<components.Option {...props} />
				</span>
			) : (
				<components.Option {...props} />
			)}
		</div>
	);
};
class NewMatter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: "",
			matterID: "",
			customMatterID: "",
			description: "",
			client: null,
			matterType: null,
			officeBranch: null,
			assignedStaff: [],
			matterTags: [],
			dateOpened: null,
			dateClosed: null,
			loading: true,
			matterPermissions: newMatterPermissions,
			needAccessToMatter: false,
		};
		this.handleChange = this.handleChange.bind(this);
		this.switchedTab = this.switchedTab.bind(this);
		this.getDefaultDropdownValue = this.getDefaultDropdownValue.bind(this);
		this.toggleNeedAccessToMatter =
			this.toggleNeedAccessToMatter.bind(this);
	}
	getDefaultDropdownValue(stateKey) {
		const returnValue =
			this.state[stateKey] && this.state[stateKey].value
				? this.state[stateKey]
				: null;
		return returnValue;
	}
	getDefaultMultiDropdownValue(stateKey) {
		const returnValue =
			this.state[stateKey] && this.state[stateKey].length
				? this.state[stateKey]
				: null;
		return returnValue;
	}
	static getDerivedStateFromProps(props, state) {
		if (state.loading && !props.loading) {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const matterNameFromSearchParams =
				urlSearchParams.get("name") || "";
			const newState = props.editMode
				? {
						loading: false,
						name: props.matterDetails.name,
						customMatterID: props.matterDetails.customMatterID,
						matterTags: props.matterDetails.tags
							? props.matterDetails.tags.map(propTagsMap)
							: null,
						assignedStaff: props.matterDetails.assignedStaff
							? props.matterDetails.assignedStaff.map(
									userOptionsMap
								)
							: null,
						matterType: props.matterDetails.matterType
							? {
									name: props.matterDetails.matterType,
									label: props.matterDetails.matterType,
									matterTypeID:
										props.matterDetails.matterTypeID,
									value: props.matterDetails.matterType,
								}
							: null,
						client: props.matterDetails.clientName
							? {
									name: props.matterDetails.clientName,
									label: props.matterDetails.clientName,
									clientID: props.matterDetails.clientID,
									value: props.matterDetails.clientName,
								}
							: null,
						officeBranch: props.matterDetails.officeBranch
							? {
									name: props.matterDetails.officeBranch,
									label: props.matterDetails.officeBranch,
									officeBranchID:
										props.matterDetails.officeBranchID,
									value: props.matterDetails.officeBranch,
								}
							: null,
						dateOpened: props.matterDetails.dateOpened
							? props.matterDetails.dateOpened
							: props.editMode
								? null
								: new Date(),
						dateClosed: props.matterDetails.dateClosed
							? props.matterDetails.dateClosed
							: null,
						matterPermissions: props.matterPermissions,
						description: props.matterDetails.description,
						characterCount: props.matterDetails.description
							? `${props.matterDetails.description.length}/1000`
							: "0/1000",
						notesTooLong:
							props.matterDetails.description &&
							props.matterDetails.description.length > 1000,
					}
				: {
						...initialState,
						name: matterNameFromSearchParams,
						dateOpened: new Date(),
						client: props.match.params.clientID
							? makeClientOption(
									props.match.params.clientID,
									props.availableClients
								)
							: null,
						loading: false,
						matterPermissions:
							// load the firm's default matter permissions if they exist, otherwise use the default new matter permissions
							props.matterPermissions || newMatterPermissions,
						characterCount: "0/1000",
					};
			return newState;
		} else {
			return null;
		}
	}
	componentDidMount() {
		if (this.props.editMode) {
			this.props.getEverythingForEditMatter(this.props.match.params.id);
		} else {
			this.props.getEverythingForNewMatter();
		}
	}
	componentWillUnmount() {
		this.props.unmountNewEditMatter();
	}
	handleChange(key, value) {
		let newState = { [key]: value };
		if (key === "description") {
			newState.characterCount = `${value.length}/1000`;
			if (value.length > 1000) {
				newState.descriptionTooLong = true;
			} else {
				newState.descriptionTooLong = false;
			}
		}
		this.setState(newState);
	}
	submit() {
		const matterInfoToSend = {
			...this.state,
		};
		if (!this.props.userRights.UPDATE_MATTER_PERMISSIONS) {
			// if the user doesn't have the right, don't send matterPermissions
			// but do send needAccessToMatter flag if creating a new matter
			delete matterInfoToSend.matterPermissions;
			if (this.props.editMode) {
				// For edit mode, also remove needAccessToMatter since it's not relevant
				delete matterInfoToSend.needAccessToMatter;
			}
		} else {
			// User has permissions - remove needAccessToMatter flag since matterPermissions takes precedence
			delete matterInfoToSend.needAccessToMatter;
		}
		if (this.props.editMode) {
			this.props.updateMatter(
				this.props.match.params.id,
				matterInfoToSend
			);
		} else {
			this.props.createNewMatter(matterInfoToSend);
		}
	}
	switchedTab(value) {
		var newURL;

		const endOfURL = tabMap[value].url;
		if (this.props.editMode) {
			newURL = `/matters/${this.props.match.params.id}/edit${endOfURL}`;
		} else {
			newURL = `/matters/new${endOfURL}`;
		}

		this.props.history.replace(newURL);
	}
	toggleNeedAccessToMatter() {
		this.setState({ needAccessToMatter: !this.state.needAccessToMatter });
	}
	render() {
		if (this.state.loading) {
			return <div />;
		} else {
			const canSubmitForm =
				this.state.name !== "" &&
				!this.props.matterLifecycleStatusObject.disabled;
			const disabledMessage = this.props.matterLifecycleStatusObject
				.disabled
				? this.props.matterLifecycleStatusObject.disabledText
				: null;

			return (
				<>
					{this.props.matterLifecycleStatusObject.disabled
						? TrashBinMessage({
								objectType: "Matter",
								deniedOperationsArray: ["edit"],
								itemLocation:
									this.props.matterLifecycleStatusObject
										.itemLocation,
							})
						: null}
					{this.props.userRights.UPDATE_MATTER_PERMISSIONS ? (
						<MaterialTabs
							activeTab={this.props.permissions ? 1 : 0}
							tabs={tabMap}
							switchedTab={this.switchedTab}
						/>
					) : null}

					{this.props.userRights.UPDATE_MATTER_PERMISSIONS ? (
						<SelfLockoutWarning
							matterPermissionGlobalSetting={
								this.state.matterPermissions
									.matterPermissionGlobalSetting
							}
							userAllowList={
								this.state.matterPermissions.userAllowList
							}
							groupAllowList={
								this.state.matterPermissions.groupAllowList
							}
							currentUserSub={this.props.userSub}
							permissionsGroups={this.props.permissionsGroups}
							singular={true}
							isUptimeAdmin={this.props.isUptimeAdmin}
							mode={this.props.editMode ? "edit" : "create"}
						/>
					) : null}
					{!this.props.userRights.UPDATE_MATTER_PERMISSIONS &&
					!this.props.editMode &&
					!this.props.currentUserIncludedInDefaultPermissions &&
					!this.state.needAccessToMatter ? (
						<div
							style={{
								padding: 10,
								backgroundColor: "#fff3cd",
								border: "1px solid #ffeaa7",
								borderRadius: 4,
								color: "#856404",
								marginTop: 10,
							}}
						>
							<strong>Warning:</strong>{" "}
							{`You will not have access to this Matter after creating it because of security policies implemented by your firm. If you need access to this Matter after creating it ${
								this.props.allowSelfAddToMatter
									? `click to enable the 'Grant me access to this Matter' toggle below.`
									: "please contact your administrator."
							}`}
						</div>
					) : null}
					{this.props.permissions ? (
						<TwoColumnWrapper
							headingText="Matter Permissions"
							iconComponent={
								<IconBriefcase
									size={16}
									style={{
										verticalAlign: "text-top",
									}}
								/>
							}
							canSubmit={canSubmitForm}
							submit={this.submit.bind(this)}
							submitDisabledHoverText={disabledMessage}
							submitButtonText={
								this.props.editMode
									? "Update Matter"
									: "Create Matter"
							}
							leftChildren={
								<div>
									<MatterPermissionsEditor
										labelType="SINGLE_MATTER"
										onChange={(permissionsState) => {
											this.setState({
												matterPermissions:
													permissionsState,
											});
										}}
										disabled={
											this.props
												.matterLifecycleStatusObject
												.disabled
										}
										initialPermissions={
											this.state.matterPermissions
										}
										availableUsers={
											this.props.availableAssignedStaff
										}
										availableGroups={
											this.props.permissionsGroups
										}
									/>
								</div>
							}
							rightChildren={null}
						/>
					) : (
						<TwoColumnWrapper
							headingText="Matter Information"
							iconComponent={
								<IconBriefcase
									size={16}
									style={{
										verticalAlign: "text-top",
									}}
								/>
							}
							canSubmit={canSubmitForm}
							disabledMessage={disabledMessage}
							submitDisabledHoverText={disabledMessage}
							submit={this.submit.bind(this)}
							submitButtonText={
								this.props.editMode
									? "Update Matter"
									: "Create Matter"
							}
							leftChildren={
								<div>
									<LabeledTextInput
										label="Matter Name*"
										name="name"
										placeholder="New Matter Name"
										defaultValue={this.state.name}
										disabled={
											this.props
												.matterLifecycleStatusObject
												.disabled
										}
										onChange={this.handleChange}
									/>
									<LabeledTextInput
										label="Custom Matter ID"
										name="customMatterID"
										placeholder="Custom Matter ID"
										defaultValue={this.state.customMatterID}
										disabled={
											this.props
												.matterLifecycleStatusObject
												.disabled
										}
										onChange={this.handleChange}
									/>
									<LabeledDropDownSelect
										label="Client"
										name="client"
										placeholder="Client Name"
										isDisabled={
											this.props
												.matterLifecycleStatusObject
												.disabled
										}
										isCreatable={
											this.props.userRights
												.CREATE_CLIENT_ALLOWED
										}
										isClearable
										isAsync
										options={this.props.availableClients.map(
											(client) => {
												const clientLifecycleStatusObject =
													getClientLifecycleStatusObject(
														client.clientLifecycleStatus
													);
												return {
													label: client.name,
													value: client.name,
													clientID: client.id,
													isDisabled:
														clientLifecycleStatusObject.IN_TRASH,
													iconComponent:
														clientLifecycleStatusObject.IN_TRASH ? (
															<IconTrash
																size={16}
																style={{
																	verticalAlign:
																		"sub",
																	marginRight: 10,
																	position:
																		"absolute",
																}}
															/>
														) : null,
													disabledHoverText:
														clientLifecycleStatusObject.IN_TRASH
															? `This client is in the Trash Bin. You cannot select it until it is restored from the Trash Bin.`
															: "",
												};
											}
										)}
										defaultValue={this.getDefaultDropdownValue(
											"client"
										)}
										handler={this.handleChange}
										components={{
											Option: clientDropdownOption,
										}}
									/>
									<div>
										<LabeledTextArea
											label="Description"
											name="description"
											disabled={
												this.props.matterDetails
													.isDeleted
											}
											onChange={this.handleChange}
											placeholder="Enter a short description or summary of this Matter or project."
											defaultValue={
												this.state.description
													? this.state.description
													: ""
											}
											style={{ height: 110 }}
										/>
										{this.state.notesTooLong ? (
											<div className="inlineErrorIndicator">
												<div>
													Notes cannot be longer than
													1000 characters
												</div>
											</div>
										) : null}
										<div style={{ textAlign: "right" }}>
											{this.state.characterCount}
										</div>
									</div>
								</div>
							}
							rightChildren={
								<div>
									<UsersDropDownSelect
										label="Assigned Staff"
										isMulti
										name="assignedStaff"
										isDisabled={
											this.props
												.matterLifecycleStatusObject
												.disabled
										}
										isAsync
										defaultValue={this.getDefaultMultiDropdownValue(
											"assignedStaff"
										)}
										options={this.props.availableAssignedStaff.map(
											userOptionsMap
										)}
										handler={this.handleChange}
									/>
									<LabeledDropDownSelect
										label="Matter Type"
										name="matterType"
										placeholder="(none)"
										isDisabled={
											this.props
												.matterLifecycleStatusObject
												.disabled
										}
										isCreatable={
											this.props.userRights
												.CRUD_MATTER_TYPES
										}
										isClearable
										isAsync
										options={this.props.availableMatterTypes
											.filter(
												(type) =>
													type.status === "active"
											)
											.map(matterTypeMap)}
										defaultValue={this.getDefaultDropdownValue(
											"matterType"
										)}
										handler={this.handleChange}
									/>
									<LabeledDropDownSelect
										label="Matter Tag(s)"
										isMulti
										name="matterTags"
										isDisabled={
											this.props
												.matterLifecycleStatusObject
												.disabled
										}
										isCreatable={
											this.props.userRights
												.CRUD_MATTER_TAGS
										}
										isAsync
										defaultValue={this.getDefaultMultiDropdownValue(
											"matterTags"
										)}
										options={this.props.availableMatterTags
											.filter(
												(tag) => tag.status === "active"
											)
											.map(tagLabelMap)}
										handler={this.handleChange}
									/>
									<LabeledDropDownSelect
										label="Location"
										name="officeBranch"
										placeholder="(none)"
										isDisabled={
											this.props
												.matterLifecycleStatusObject
												.disabled
										}
										isCreatable={
											this.props.userRights
												.CRUD_OFFICE_LOCATIONS
										}
										isClearable
										isAsync
										options={this.props.availableOfficeBranches
											.filter(
												(office) =>
													office.status === "active"
											)
											.map((officeBranch) => ({
												label: officeBranch.name,
												value: officeBranch.name,
												officeBranchID: officeBranch.id,
											}))}
										defaultValue={this.getDefaultDropdownValue(
											"officeBranch"
										)}
										handler={this.handleChange}
									/>
									<div style={{ display: "flex", gap: 16 }}>
										<LabeledDatePicker
											label="Opened Date"
											name="dateOpened"
											disabled={
												this.props
													.matterLifecycleStatusObject
													.disabled
											}
											isClearable
											defaultValue={
												this.props.editMode
													? this.state.dateOpened ||
														null
													: new Date()
											}
											placeholderText="Select a Date"
											handler={this.handleChange}
										/>

										<LabeledDatePicker
											label="Closed Date"
											name="dateClosed"
											disabled={
												this.props
													.matterLifecycleStatusObject
													.disabled
											}
											isClearable
											defaultValue={
												this.props.editMode &&
												this.state.dateClosed
													? this.state.dateClosed
													: null
											}
											placeholderText="Select a Date"
											handler={this.handleChange}
										/>
									</div>
									{!this.props.userRights
										.UPDATE_MATTER_PERMISSIONS &&
									!this.props.editMode &&
									this.props.allowSelfAddToMatter ? (
										<LabeledSwitch
											upperLabel="Matter Access"
											label="Grant me access to this Matter"
											switchValue={
												this.state.needAccessToMatter
											}
											handleSwitchValueChange={
												this.toggleNeedAccessToMatter
											}
										/>
									) : null}
								</div>
							}
						/>
					)}
				</>
			);
		}
	}
}
const mapStateToProps = (state) => {
	return {
		availableMatterTags: state.matter.availableMatterTags,
		availableMatterTypes: state.matter.availableMatterTypes,
		availableAssignedStaff: state.matter.availableAssignedStaff,
		availableOfficeBranches: state.matter.availableOfficeBranches,
		availableClients: state.matter.availableClients,
		matterDetails: state.matter.matterDetails,
		matterLifecycleStatusObject: getDisabledStateFromLifecycleStatuses({
			matterLifecycleStatus:
				state.matter.matterDetails.matterLifecycleStatus,
		}),
		clientDetails: state.client.clientDetails,
		permissionsGroups: state.matter.permissionsGroups,
		matterPermissions: state.matter.matterPermissions,
		loading: state.matter.newEditMatterLoading,
		userRights: state.user.userRights,
		userSub: state.user.cognitoUser.attributes.sub,
		isUptimeAdmin: state.user.isUptimeAdmin,
		allowSelfAddToMatter:
			state.matter.matterPermissions?.allowSelfAddToMatter || false,
		currentUserIncludedInDefaultPermissions:
			state.matter.matterPermissions
				?.currentUserIncludedInDefaultPermissions || false,
	};
};
NewMatter.propTypes = {
	createNewMatter: PropTypes.func.isRequired,
	updateMatter: PropTypes.func.isRequired,
	getEverythingForNewMatter: PropTypes.func.isRequired,
	getEverythingForEditMatter: PropTypes.func.isRequired,
	unmountNewEditMatter: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
	createNewMatter,
	updateMatter,
	getEverythingForNewMatter,
	getEverythingForEditMatter,
	unmountNewEditMatter,
})(NewMatter);
